
    <mat-select [formControl]="formControl" [formlyAttributes]="field">
    <mat-option> --- </mat-option>
      <mat-optgroup *ngFor="let item of items" label="{{ 'properties.structures.' + item.item | translate }}">
        <mat-option *ngFor="let subItem of item.values" [value]="subItem._id">
          {{ subItem.nome }}
        </mat-option>
      </mat-optgroup>
    </mat-select>
  